/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { HourSelectionEvent } from './hour-selection-event';
import { CalendarSelection } from './calendar-selection';
import { CalendarTasksGroup } from '../calendar-tasks-group';

export class WeekSelectionEvent implements CalendarSelection {
  public date: Date;
  public hourSelection: HourSelectionEvent;

  constructor(date: Date, hourSelection: HourSelectionEvent) {
    this.date = date;
    this.hourSelection = hourSelection;
  }

  getStart(): Date {
    const d = new Date(this.date);
    d.setHours(
      this.hourSelection.start.hours,
      this.hourSelection.start.minutes,
    );
    return d;
  }

  getEnd(): Date {
    const d = new Date(this.date);
    if (
      this.hourSelection.end.hours === 24 &&
      this.hourSelection.end.minutes === 0
    ) {
      d.setHours(23, 59);
    } else {
      d.setHours(this.hourSelection.end.hours, this.hourSelection.end.minutes);
    }
    return d;
  }

  getResource(): CalendarTasksGroup {
    return this.hourSelection.resource;
  }

  setResource(resource: CalendarTasksGroup) {
    this.hourSelection.resource = resource;
  }

  getPosition(): { x: number; y: number } {
    return { x: this.hourSelection.event.x, y: this.hourSelection.event.y };
  }

  getEvent(): MouseEvent {
    return this.hourSelection.event;
  }
}
